import React from 'react';
import styles from '@/styles/components/StatCard.module.css';

const StatCard = ({ icon: Icon, title, value }) => (
  <div className={styles.statCard}>
    <Icon className={styles.icon} />
    <div className={styles.content}>
      <p className={styles.title}>{title}</p>
      <p className={styles.value}>{value}</p>
    </div>
  </div>
);

export default StatCard;
